import React from "react";
import { Button, ButtonProps, styled } from "@mui/material";
import DebouncedButton from "components/base/DebouncedButton";

interface Props extends ButtonProps {
  customcolor?: string;
}

const BorderColor = (props: any) => {
  if (props.disabled) return "default";
  if (props.customcolor) return props.customcolor;
  return props.theme.palette.grey[600];
};

const StyledButton = styled(Button)<Props>`
  && {
    text-transform: none;
    min-width: 240px;
    border: solid;
    border-color: ${(props) => BorderColor(props)};
    min-height: 2em;
    font-size: 16px;
    border-width: 2px;
    margin-top: 5px;
    margin-bottom: 5px;
    color: ${(props) => BorderColor(props)};
  }
  & svg {
    color: ${(props: Props) => BorderColor(props)};
  }
`;

const LandingPageButton = (props: any) => (
  <DebouncedButton Component={StyledButton} variant="outlined" {...props} />
);

export default LandingPageButton;
